import React from 'react'
import {
  NewsWidgetContainer,
  NewsTitle,
  NewsCardsContainer,
  ReadMoreLink,
  NewsCard,
  NewsCardText
} from './styles'

const { isIE11 } = require('../../../common/utils/browserUtilities')

const EmploymentLawNewsWidget = (props) => {
  const { blogPosts } = props
  const finalPosts = isIE11() ? blogPosts.slice(0, 2) : blogPosts
  return (
    <NewsWidgetContainer>
      <NewsTitle>
        Employment Law News
      </NewsTitle>
      <NewsCardsContainer>
        {finalPosts.map((post, index) => (
          <NewsCard
            index={index}
            href={post.link}
            target="_blank"
            data-testid={`news-card-${post.id}`}
            key={post.id}
          >
            <NewsCardText>
              {post.title.rendered}
            </NewsCardText>
          </NewsCard>
        ))}
      </NewsCardsContainer>
      <ReadMoreLink href="https://govdocs.com/blog?ref=dashboard">
        Read More
      </ReadMoreLink>
    </NewsWidgetContainer>
  )
}

export default EmploymentLawNewsWidget
